var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLobyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 37,
    viewBox: "0 0 73 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_22573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 28.7736V0H4.34717V28.7736H0Z",
    fill: "#022B3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0114 29.0142C14.864 29.0142 12.3261 28.0309 10.3987 26.0448C8.4708 24.0782 7.50684 21.4901 7.50684 18.2597C7.50684 15.0292 8.4708 12.4407 10.4184 10.4541C12.3463 8.46748 14.8837 7.48468 18.0114 7.48468C21.1391 7.48468 23.677 8.48796 25.6242 10.4746C27.5718 12.4611 28.5357 15.0697 28.5357 18.2597C28.5357 21.4497 27.5718 24.0787 25.6439 26.0448C23.6962 28.0314 21.1588 29.0142 18.0114 29.0142ZM18.0114 25.2422C19.8212 25.2422 21.2967 24.5798 22.4177 23.2756C23.5392 21.9713 24.0896 20.3062 24.0896 18.2592C24.0896 16.2122 23.5387 14.5271 22.4177 13.2228C21.2962 11.9186 19.8212 11.2767 18.0114 11.2767C16.2017 11.2767 14.7459 11.9186 13.6446 13.2228C12.5231 14.5271 11.9727 16.1922 11.9727 18.2592C11.9727 20.3261 12.5236 21.9913 13.6446 23.2955C14.7464 24.5998 16.2017 25.2417 18.0114 25.2417V25.2422Z",
    fill: "#022B3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6561 10.3737C51.4461 12.2999 52.351 14.9284 52.351 18.2592C52.351 21.5899 51.4461 24.0582 49.6167 26.0443C47.7872 28.0309 45.466 29.0137 42.6135 29.0137C39.761 29.0137 37.4003 27.9101 35.8859 25.7228L35.3547 28.7726H31.5776V0H35.9248V10.8554C37.5573 8.60823 39.7998 7.48466 42.613 7.48466C45.4261 7.48466 47.8458 8.44802 49.6556 10.3742L49.6561 10.3737ZM46.2724 23.336C47.3742 22.0317 47.9246 20.3461 47.9246 18.2597C47.9246 16.1733 47.3737 14.5276 46.2527 13.2233C45.1312 11.9191 43.6759 11.2772 41.8858 11.2772C40.0957 11.2772 38.64 11.9191 37.5386 13.2034C36.4368 14.5076 35.8864 16.1728 35.8864 18.2197C35.8864 20.2667 36.4373 22.0122 37.5386 23.3165C38.6405 24.6208 40.0957 25.2831 41.8858 25.2831C43.6759 25.2831 45.1514 24.6412 46.2724 23.337V23.336Z",
    fill: "#022B3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3905 28.8939L52.3647 7.72522H57.0073L62.7512 23.7173L68.3577 7.72522H73.0003L63.6561 32.0645C63.2824 33.0073 62.9678 33.77 62.7118 34.3116C62.4366 34.8532 62.1018 35.3348 61.7085 35.7966C60.9217 36.6795 59.9381 37.0005 58.4429 37.0005H53.7806V33.0877H56.8296C57.6557 33.0877 58.246 32.9474 58.5802 32.6864C58.9145 32.4253 59.2493 31.8438 59.5836 30.9608L60.39 28.8939H60.3905Z",
    fill: "#022B3E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_22573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobyLogo);
export default __webpack_public_path__ + "static/media/LobyLogo.a89878282be53f58a645a3113cb4d34f.svg";
export { ForwardRef as ReactComponent };